import Scrollbar from 'smooth-scrollbar';

class Filter {

	constructor(el) {
		this.filter = el;
		this.container = this.filter.closest('[data-filter-container]');
		this.product = this.container.find('[data-filter-products]');
		this.filterHide = this.container.find('[data-filter-hide]');
		this.tools = this.container.find('[data-catalog-tool]');
		this.resultsList = this.container.find('[data-catalog-results-list]');
		this.filterResultsList = this.filter.find('[data-filter-list]');
		this.checkboxes = this.filter.find('[data-accordion-item]');
		this.filterResults = this.container.find('[data-catalog-results]');
		this.filterText = '';
		this.filterPopupText = '';
		this.allFiltersClear = this.container.find('[data-catalog-results-clear]');
		this.openFilter = this.container.find('[data-open-filter-btn]');
		this.closeFilter = this.filter.find('[data-close-filter-btn]');
		this.results = this.filter.find('[data-filter-results]');
		this.resultsContainer = this.container.find('[data-catalog-results-container]');
		this.filterContainer = this.container.find('[data-catalog-filter-container]');
		this.toolsContainer = this.container.find('[data-catalog-tools-container]');
	}

	initialize() {
		const that = this;
		// let isIOS = [
		// 	'iPad Simulator',
		// 	'iPhone Simulator',
		// 	'iPod Simulator',
		// 	'iPad',
		// 	'iPhone',
		// 	'iPod'
		// ].includes(navigator.platform)
		// // iPad on iOS 13 detection
		// || (navigator.userAgent.includes("Mac") && "ontouchend" in document)

		// if (!isIOS) {
		// 	this.filterResults.addClass('android');
		// }

		// this.filterHide.on('click', function() {
			// let list = that.container.find('[data-catalog-list]');

			// that.filter.parent().toggleClass('d-none');
			// $(this).toggleClass('hide');
			// list.toggleClass('wrap');

			// let classes = that.product.attr("class");
			// that.product.attr('class', '').addClass(that.product.attr('swap-col'));
			// that.product.attr('swap-col', classes);
		// });

		this.tools.on('click', function() {
			let listItems = that.container.find('[data-catalog-list]').find('[data-catalog-item-sm]');

			that.tools.removeClass('active');
			$(this).addClass('active');

			let attr = $(this).attr('data-catalog-tool');

			listItems.attr('class', '');

			if (attr === 'sm') {
				listItems.attr('class', listItems.attr('data-catalog-item-sm'));
			} else if (attr === 'md') {
				listItems.attr('class', listItems.attr('data-catalog-item-md'));
			}

			localStorage.setItem("tools_click", true);
		});

		this.checkboxes.on('click', function() {
			that.filterText = '';
			that.filterPopupText = '';
			let categories = that.filter.find('[data-accordion]');

			categories.each((index) => {
				let elem = $(categories[index])

				that.checkCategory(elem);
			});

			that.createFilterResult()
		});

		this.allFiltersClear.on('click', function() {
			that.filterText = '';
			that.filterPopupText = '';
			that.checkboxes.find('input').prop('checked', false);

			if (typeof CatalogFilter !== 'undefined') {
				CatalogFilter.func.clearCatalogFilter();
			}

			that.createFilterResult();
		});

		this.openFilter.on('click', function() {
			that.filter.addClass('show');
			$('body').addClass('overflow-y');
		});

		this.closeFilter.on('click', function() {
			that.filter.removeClass('show');
			$('body').removeClass('overflow-y');
		});

		this.checkSize();
		this.checkCategories();
		this.setResultsWidth();
		let checkWidth = $(window).width();

		$(window).on('resize', function() {
			if (checkWidth !== $(window).width()) {
				that.checkSize();
				checkWidth = $(window).width();
			}
		});

		this.initScrollBar();
	}

	initScrollBar() {
		let scrollBar = Scrollbar.init(this.filterResults[0], {
			damping: 0.5,
			thumbMinSize: 20,
			renderByPixels: true,
			alwaysShowTracks: true
		})
	}

	checkCategory(category) {
		let title = category.find('[data-accordion-title]').text();
		let html = '';
		let filterHtml = '';
		let inputs = category.find('[data-accordion-item]').find('input');

		inputs.each((i) => {
			let el = $(inputs[i]);
			let name= el.attr('name')
			if (el.prop('checked')) {
				let text = el.parent().find('[data-checkbox-text]').text();
				html += `
				<div class="catalog__results-item__inner" data-results-item=${name}>${text}<div class="catalog__results-item__delete" data-results-delete></div></div>
				`
				filterHtml += `<p class="filter__results-item" data-results-item=${name}>${text}<button class="filter__results-item__delete" data-results-delete></button></p>`
			}
		});

		if (html.length > 0) {
			this.filterText += `<div class="catalog__results-item"><div class="catalog__results-item__title">${title}: </div>${html}</div>`
			this.filterPopupText += `
			<div class="row">
				<div class="col-4">
					<div class="filter__results-title">${title}:</div>
				</div>
				<div class="col-8 d-flex flex-wrap justify-content-end">
					${filterHtml}
				</div>
			</div>`
		}
	}

	createFilterResult() {
		const that = this;

		if (that.filterText.length > 0) {
			that.filterResults.addClass('show');
			that.filterResultsList.closest('[data-filter-results]').addClass('show');
		} else {
			that.filterResults.removeClass('show');
			that.filterResultsList.closest('[data-filter-results]').removeClass('show');
		}

		that.resultsList.html(that.filterText);
		that.filterResultsList.html(this.filterPopupText);
		let clearFilter = that.container.find('[data-results-delete]');

		clearFilter.on('click', function() {
			that.triggerClearFilter(this);
		});
	}

	triggerClearFilter(el) {
		const that = this;

		that.filterText = '';
		that.filterPopupText = '';
		let name = $(el).closest('[data-results-item]').attr('data-results-item');

		that.checkboxes.each((i) => {
			if ($(that.checkboxes[i]).find('input').attr('name') === name) {
				let currentCheckbox = $(that.checkboxes[i]).find('input');
				currentCheckbox.prop('checked', false);
			}
		});

		that.checkCategories();

		if (typeof CatalogFilter !== 'undefined') {
			CatalogFilter.func.reloadCatalog();
		}
	}

	checkCategories() {
		const that = this;

		let categories = that.filter.find('[data-accordion]');

		categories.each((index) => {
			that.checkCategory($(categories[index]));
		});

		that.createFilterResult();
	}

	checkSize() {
		const ww = $(window).width();
		let tools_clicked = localStorage.getItem("tools_click");

		if(!tools_clicked) {
			if (ww >= 768) {
				this.tools.parent().find('[data-catalog-tool=md]').trigger('click');
			} else {
				this.tools.parent().find('[data-catalog-tool=sm]').trigger('click');
			}
		}
	}

	setResultsWidth() {
		let rowWidth = this.resultsContainer.parent().width();
		let resultsWidth = rowWidth - this.filterContainer.width() - this.toolsContainer.width() - 45;
		this.resultsContainer.css({'max-width': `${resultsWidth}px`})
	}
}

export {Filter}

function initFilterPanel(){
	let filters = [];
	if ($('[data-filter]').length > 0) {
		$('[data-filter]').each(function(i) {
			filters[i] = new Filter($(this));
			filters[i].initialize();
		});
	}
}

$(window).on('load', function() {
	initFilterPanel()
});

$(document).ajaxComplete(function(event, xhr, options) {
	let isMobile = BX.browser.IsMobile();

	if (options.url.includes('catalog') && options.url.includes('show_filter=Y') && isMobile == false) {
		let filterParent = $('.catalog__wrapper-filter');
		$('body').addClass('overflow-y');
		$('.filter-overlay').fadeIn(300);
		filterParent.show().animate({ left: '0%' }, 500, function() {
			filterParent.addClass('filter-show');
		});
	}

	initFilterPanel();
});
